<template>
 <div class="aui-content">
	<ul class="aui-list aui-media-list maui-detail-list">
		<li class="aui-list-item">
			 
      <!-- :interval="4000" -->
  <el-carousel :interval="3000" arrow="always" height="200px">
    <el-carousel-item v-for="(item, index) in pictureUrls" :key="index">
      <div  style=" text-align:center;"><img :src="item.url" ></div>
    </el-carousel-item>
  </el-carousel>
				<div class="aui-media-list-item-inner">
				<div class="aui-list-item-inner">
					<div class="aui-list-item-text">
						<div class="aui-list-item-title">{{title}}  {{number}}{{unit}}</div>
					</div>
					<div class="maui-list-item">
						<div class="aui-label maui-label-green">{{goodsClassName}}</div>
					</div>
					<div class="aui-list-item-text maui-price-text">
					<div v-if="estimatedPrice!=''">
          <!-- <img src="../assets/img2.jpg"> -->
         	￥ <span>{{estimatedPrice}} </span>
          </div>
          <div v-else>
          面谈
          </div>
					</div>
				</div>
			</div>
      <div v-if="bidDate!=''">
     <div class="aui-info maui-time-text">
				<div class="aui-info-item">
					开标时间：
         {{bidDate}} 
				 </div>
              <div class="aui-info-item">截止倒计时：
              <nut-countdown  :endTime="bidDate"  showDays :endText="'竞标已关闭'"></nut-countdown> 
              </div>
			</div> 
    </div>
    <div v-else>
     
    </div>
		</li>
    <!-- <el-button style="line-height: 0;padding: 12px 160px;" type="success" plain @click="dialogFormVisible = true">我要竞标</el-button> -->
	</ul>
  <div class="aui-content maui-info-textbox">
	<h2>基本信息</h2>
	<ul class="aui-list aui-form-list" v-for="(item,i) in arr" :key="i">
		<li class="aui-list-item">
			<div class="aui-list-item-inner">
				<div class="aui-list-item-label">
					{{item.name}}
				</div>
				<div class="aui-list-item-input" >
					<input type="text" v-for="(item, index) in item.infoList" :key="index" v-model="item.name" readonly>
				</div>
			</div>
		</li>
	</ul>
</div>
<div class="aui-content maui-info-textbox aui-content">
	<h2>信息描述</h2>
	<div class="maui-textbox"  v-html="content">
	{{content}}
	</div>
</div>
<div class="aui-content maui-info-textbox">
	<h2>竞价信息</h2>
	<div class="maui-textbox">
		<div class="battery-detail-cctoe" >{{message}}</div>
	</div>
</div> 
<div>
<el-dialog title="竞价价格" :visible.sync="dialogFormVisible" style="padding: 5px 10px 20px;margin-top: 5vh;">
  <el-form :model="form">
      <el-input maxlength="16" type="text"  placeholder="竞价价格" style="width:160px;" label-width="30px" show-word-limit v-model="form.msg"></el-input>
<!--   
    <nut-price  :price="1010"  :needSymbol="false"  :thousands="true"/> -->
  </el-form>
  <div slot="footer" class="dialog-footer" style="line-height: 0;">
    <!-- <el-button @click="dialogFormVisible = false"  style="line-height:0;">取 消</el-button> -->
    <el-button @click="dialogFormVisible = false" type="success" plain  style="line-height:0;  padding: 12px 50px;">提 交</el-button>
  </div>
</el-dialog>
</div>
</div>
</template>
<script>
import zkTimeDown from '@/components/HomeTimer'   //  引入倒计时
import CountDown from 'vue2-countdown'
  export default {
    name: "ScrollerOne",
    data() {
      return {
        //noDate: false,//这是一个判断是否加载的开关
        arr: [],
        showPage: 1,
        pageSize: 4,
        xqid:'',
        id:'',
        content:'',
        goodsClassName:'',
        pictureUrl:'',
        companyList:[],
        openid:'',
        speciDetailList:'',
        pictureUrls:[],
        estimatedPrice:'',
        title:'',
        bidDate:'',
        unit:'',
        number:'',
         dialogTableVisible: false,
        dialogFormVisible: false,
        message:'',
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formLabelWidth: '120px'
      }
    },
    serverTime:'',
    created() {
      this.getData();
    },
    
    methods: {
      getData() {
          this.openid =localStorage.getItem('openid')
              this.xqid = this.$route.query.xqid
               console.log("_+_openid+_+_+_+"+ this.openid)
        // Axios.get('http://gank.io/api/data/%E7%A6%8F%E5%88%A9/5/1').then((response) => {
            //http://gank.io/api/data/%E7%A6%8F%E5%88%A9/' + that.pageSize + '/' + that.showPage
        this.$axios.get('/micro/permission_order-view/supply/read/supplyInfo?id='+this.xqid+'').then((res) => {
         this.id=res.data.data.id
         this.companyList=res.data.data.companyList
          this.arr=res.data.data.speciDetailList
           this.unit=res.data.data.unit
         this.pictureUrls=res.data.data.pictureUrls
         this.content=res.data.data.content
          this.estimatedPrice=res.data.data.estimatedPrice
         this.title=res.data.data.title
          this.bidDate=this.$moment(res.data.data.bidDate).format("YYYY-MM-DD hh:mm:ss");
            console.log( "///////////////////////"+this.bidDate)
          this.number=res.data.data.number
          this.goodsClassName=res.data.data.goodsClassName
        }).catch((error) => {
          console.log(error)
          //没网的时候，或者接口调用异常的时候
         // this.$refs.myscroller.finishInfinite(true);//这个方法是不让它加载了，显示“没有更多数据”，要不然会一直转圈圈
        })
        this.$axios.get('/micro/permission_order-view/bidding/read/querybidWXResult?openId='+this.openid+'&supplyId='+this.xqid+'').then((res) => {
         this.message=res.data.message
            console.log( "///////////////////////"+this.message)
        }).catch((error) => {
          console.log(error)
          //没网的时候，或者接口调用异常的时候
         // this.$refs.myscroller.finishInfinite(true);//这个方法是不让它加载了，显示“没有更多数据”，要不然会一直转圈圈
        })
      },
      
    },
  }
</script>
 
<style scoped>
 
  .container {
    display: flex;
    width: 375px;
    height: 100%;
    /* background: red; */
    flex-direction: column;
  }

  .itemStyle {
    display: flex;
    width: 375px;
    height: 100px;
    /* background: coral;
    border: 1px blue solid; */
    margin-bottom: 5px;
  }
  .el-carousel__item h3 {
    color: #f8fafc;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
 

  .el-carousel__item:nth-child(2n) {
    background-color: #f8fafc;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #f8fafc;
  }
  
</style>




// WEBPACK FOOTER //
// src/components/biddingform.vue